import { MOCK_BACKEND, SERVER_URL } from "../constants";
import axios from 'axios';
function mockCreateTask(token, file, taskName, sourceLanguage) {
  return {"taskId": "51c77e4f-4222-4e59-95f4-139f25c57e8d"};
}

/**
 * 
 * @param {the token of the logged in user} token 
 * @param {the audio file to upload} file 
 * @param {the name of the task to create} taskName 
 * @param {the language of the audio} sourceLanguage 
 * @returns the response from the server if succeeded, otherwise returns false
 */

export default async function createTask2(
  token,
  file,
  taskName,
  sourceLanguage,
  mediaHash,
  setUploadProgress,
  iso6393
) {
  if (MOCK_BACKEND) {
    return mockCreateTask(token, file, taskName, sourceLanguage);
  }
  let response;
  var myHeaders = new Headers();
  myHeaders.append("Authorization", "Token " + token);
    
  var formdata = new FormData();
  formdata.append("audioFile", file.current.files[0]);
  formdata.append("taskName", taskName);
  formdata.append("sourceLanguage", sourceLanguage.split(' ').join('-'));
  formdata.append("mediaHash", mediaHash);
  formdata.append("iso6393", iso6393);
  

  response = await axios.post(SERVER_URL + "/v1/createtask/", formdata, {
    onUploadProgress: (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      console.log(`File upload is ${percentCompleted}% complete`);
      setUploadProgress(percentCompleted)
    },
    headers:{ Authorization: "Token " + token }
  });


  /*var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect:'follow'
  };

  response = await fetch(
    SERVER_URL + "/v1/createtask/",
    requestOptions
  );*/
    console.log(response)
  if (response.status === 200) return response;
  return false;
}
